// GET PRODUCT BY ID
export const productById = (state) => {
  return (productid) => {
    return state.allProducts.find((product) => product.id == productid);
  };
};

// GET PRODUCT BY CATEGORY
export const productByCategory = (state) => {
  return (productcat) => {
    return state.allProducts.filter(
      (product) => product.category == productcat
    );
  };
};

// GET RELATED PRODUCTS
export const RelatedProducts = (state) => {
  return (categoryName) => {
    return state.allProducts.filter(
      (product) => product.category == categoryName
    );
  };
};

// CALCULATE CART TOTL PRICE
export const cartTotalQuantity = (state) => {
  let total = 0;
  state.cart.forEach((item) => {
    total += item.quantity;
  });

  return total;
};

// CALCULATE CART TOTL PRICE
export const cartTotalPrice = (state) => {
  let total = 0;
  state.cart.forEach((item) => {
    total += item.product.price * item.quantity;
  });

  return total;
};

// CHECKOUT INFO
export const checkoutInfo = (state) => {
  return state.checkoutInfo;
};

// CHECKOUT
export const checkout = (state) => {
  return state.checkout;
};

// PAYSTACK PAYMENT
export const paystackPayment = (state) => {
  return state.paystackPayment;
};

// SHOW SEARCH INPUT
export const showSearch = (state) => {
  return state.showSearch;
};
